import { translate } from '@portal/services/i18n';
import {
  formatDateMonthDay,
  formatDateYearMonthDay,
} from '@portal/utils/format';
import React from 'react';

interface IProps {
  initialDate: string;
  finalDate: string;
  longRangeSelectorFormat?: boolean;
}

const AdvancedHeaderDate = ({
  initialDate,
  finalDate,
  longRangeSelectorFormat,
}: IProps) => {
  const renderHeaderDate = () =>
    `${
      initialDate &&
      (longRangeSelectorFormat
        ? formatDateYearMonthDay(initialDate)
        : formatDateMonthDay(initialDate))
    } ${
      finalDate
        ? translate('PAGES.EXTRACT.DATE.UNTIL')
        : translate('PAGES.EXTRACT.DATE.UNTIL_TODAY')
    } ${
      finalDate &&
      (longRangeSelectorFormat
        ? formatDateYearMonthDay(finalDate)
        : formatDateMonthDay(finalDate))
    }`;

  return <p className="extract-page__header-date">{renderHeaderDate()}</p>;
};

export default AdvancedHeaderDate;
